import type { BasicReportDto, ReportRequestDto } from '../dto';
import type { BasicReport, ReportRequest } from '../models';

export const mapBasicReportToDto = (model: BasicReport): BasicReportDto => ({
  ...model,
});

export const mapReportRequestToDto = (
  model: ReportRequest,
): ReportRequestDto => ({
  data: model.data.map(mapBasicReportToDto),
});
